import { ReactElement } from 'react';
import { UseFormReturn, useFieldArray } from 'react-hook-form';

import { PersonFormArray } from '../PersonFormArray';
import { ContactsFormFields } from './ContactsFormUtils';

type Props = {
  icon: ReactElement;
  title: string;
  subtitle: string;
  contactTitle?: string;
  fieldName: keyof ContactsFormFields;
  duplicateFieldName?: keyof ContactsFormFields;
  contactsForm: UseFormReturn<ContactsFormFields>;
  isFinalizationMode?: boolean;
  shouldHideMakeAdmin?: boolean;
  duplicateModeCheckbox?: { label: string };
  isMultiSelect?: boolean;
  tooltipLabel?: string;
};

export const ContactsFormSection = ({
  icon,
  title,
  subtitle,
  contactTitle,
  fieldName,
  duplicateFieldName,
  contactsForm,
  isFinalizationMode,
  shouldHideMakeAdmin = false,
  isMultiSelect = false,
  duplicateModeCheckbox,
  tooltipLabel,
}: Props) => {
  'use no memo';
  const { control, formState, watch } = contactsForm;
  const { errors } = formState;

  const { isDuplicateMode } = watch(`${fieldName}.0`);
  const activeName =
    isDuplicateMode && duplicateFieldName ? duplicateFieldName : fieldName;
  const fields = watch(activeName);
  const { append, remove } = useFieldArray({
    control,
    name: activeName,
  });

  const isOnboardingContact = fieldName === 'onboardingContacts';

  return (
    <PersonFormArray
      icon={icon}
      title={title}
      subtitle={subtitle}
      personTitle={contactTitle}
      tooltipLabel={tooltipLabel}
      control={control}
      errors={errors}
      fieldName={fieldName}
      activeName={activeName}
      fields={fields}
      append={append}
      remove={remove}
      isDuplicateMode={isDuplicateMode}
      isFinalizationMode={isFinalizationMode}
      shouldHideMakeAdmin={shouldHideMakeAdmin}
      isAdminFixed={isOnboardingContact}
      duplicateModeCheckbox={duplicateModeCheckbox}
      isMultiSelect={isMultiSelect}
    />
  );
};
